import { UserReportResponse as ApiUserReportResponse } from '@zond/api-interfaces';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityChartTool } from '../../../tools/ActivityChartTool';

// Import types from the tool file or from the common types file
interface ActivityData {
  createdAt: string;
  clicks: number;
  keyPress: number;
  mouseActivity: number;
}

interface SessionData {
  SessionActivity: ActivityData[];
  id?: number;
  startTime?: string;
  endTime?: string;
}

interface UserReportResponse {
  sessions: SessionData[];
  userId?: number;
  date?: string;
}

interface ActivityChartProps {
  data?: ApiUserReportResponse;
  isLoading?: boolean;
}

export const ActivityChart: React.FC<ActivityChartProps> = ({ data, isLoading = false }) => {
  const { t } = useTranslation('reports');
  return (
    <div className="bg-card rounded-lg border shadow-sm">
      <div className="flex flex-col space-y-1.5 p-6">
        <h3 className="text-2xl font-semibold leading-none tracking-tight">{t('sections.activity')}</h3>
      </div>
      <div className="p-6 pt-0">
        <ActivityChartTool data={data} isLoading={isLoading} width="100%" height={384} />
      </div>
    </div>
  );
};
